export default "__VITE_ASSET__39b80223__"